package koala.html

import koala.css.Class
import koala.css.ModifierSet
import koala.css.addModifiers
import kotlinx.html.FlowContent
import kotlinx.html.OL
import kotlinx.html.UL
import kotlinx.html.ol
import kotlinx.html.ul

fun FlowContent.olist(
    axis: ListAxis = ListAxis.Column,
    modifiers: ModifierSet? = null,
    block: OL.() -> Unit = {},
) {
    ol {
        configureListing(axis, modifiers)
        block()
    }
}

fun FlowContent.ulist(
    axis: ListAxis = ListAxis.Column,
    modifiers: ModifierSet? = null,
    block: UL.() -> Unit = {},
) {
    ul {
        configureListing(axis, modifiers)
        block()
    }
}

internal fun TagContext.configureListing(
    axis: ListAxis,
    modifiers: ModifierSet? = null,
) {
    val axisClass = when (axis) {
        ListAxis.Row -> ListKey.RowClass
        ListAxis.Column -> ListKey.ColumnClass
    }
    addModifiers(modifiers, ListKey.Class, axisClass)
}

enum class ListAxis {
    Row,
    Column
}

object ListKey {
    val Class = Class("listing")
    val RowClass = Class("row-listing")
    val ColumnClass = Class("column-listing")
}

// language="CSS"
val ListingCss get() = """
${ListKey.Class} {
    display: flex;
    min-width: 0;
    min-height: 0;
    gap: var(--unit-spacing);
    list-style: none;
}

${ListKey.ColumnClass} {
    flex-direction: column;
}

${ListKey.RowClass} {
    flex-direction: row;
}
"""